import { Component, OnInit, ViewChild, ElementRef, Input, EventEmitter, Output, OnChanges, SimpleChanges } from '@angular/core';
import { Devicetype } from '../../models/imports/generic';
import { WindowService } from '../../services/window-service';
import { DataService } from '@components/public_api';
import { BaseOlsControlDirective } from '../base/base-ols-control';
import { Observable } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-multiline-text',
  templateUrl: './multiline-text.component.html',
  styleUrls: ['./multiline-text.component.scss']
})
export class MultilineTextComponent extends BaseOlsControlDirective implements OnInit {
  @ViewChild('textAreaField', { static: true }) textAreaElement: ElementRef;

  @Input() maxlength: number = 1200;
  @Input() rows: number;
  @Input() placeholder: string = '';
  @Input() alwaysShowBorder: boolean = false;
  @Input() autoFocus: boolean = false;

  _value: string = '';
  get value(): string {
    return this._value;
  }
  @Input() set value(val: string) {
    this._value = val ?? '';
    this.lengte = this._value.length;

    this.valueChange.emit(this._value);
  }

  @Output() valueChange = new EventEmitter<string>();

  lengte = 0;
  submitClicked$: Observable<boolean>;
  submitClicked: boolean;

  constructor(
    private _dataService: DataService,
    private _windowService: WindowService
  ) {
    super();
  }

  ngOnInit(): void {
    if (this.rows == undefined)
      this.rows = 8;

    if (this._windowService.deviceType() <= Devicetype.TabletPortrait && this.rows > 4)
      this.rows = 4;

    if (this.autoFocus)
      this.textAreaElement.nativeElement.focus();

    this.submitClicked$ = this._dataService.submitClicked;
    this.submitClicked$
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(sc => { this.submitClicked = sc; });
  }
}
